import EventTypes from "../../../shared/EventTypes";
import AbstractAction from "../AbstractAction";

export default class AddPolyCoordinateAction extends AbstractAction {
    constructor(provider, element, potentialCoordinate) {
        super(provider);

        this.element = element;
        this.segmentIndex = potentialCoordinate.segmentIndex;

        this.newCoord = this.element.insertCoordinateOnSegment(this.segmentIndex, potentialCoordinate.absX, potentialCoordinate.absY);
        this.coordIndex = this.newCoord.index;

        // Store initial offset between new coord and mouse for smooth absolute tracking
        let mouseAbsX = (this.p.mouseX - this.view.posX) / this.view.scale;
        let mouseAbsY = (this.p.mouseY - this.view.posY) / this.view.scale;
        this.offsetX = this.newCoord.absX - mouseAbsX;
        this.offsetY = this.newCoord.absY - mouseAbsY;
    }

    update() {
        let moveX, moveY;
        if (this.settings.snapToGrid) {
            [moveX, moveY] = this.view.snappedCoordinate.diff(this.newCoord);
        } else {
            let mouseAbsX = (this.p.mouseX - this.view.posX) / this.view.scale;
            let mouseAbsY = (this.p.mouseY - this.view.posY) / this.view.scale;
            moveX = mouseAbsX + this.offsetX - this.newCoord.absX;
            moveY = mouseAbsY + this.offsetY - this.newCoord.absY;
        }

        this.newCoord.drag(moveX, moveY);
    }

    finish() {
        this.savedAbsX = this.newCoord.absX;
        this.savedAbsY = this.newCoord.absY;
        super.finish();
        this.emit(EventTypes.UPDATE_ELEMENT_SHAPE, this.element);
    }

    undo() {
        this.element.removeCoordinateAtIndex(this.coordIndex);
        this.emit(EventTypes.UPDATE_ELEMENT_SHAPE, this.element);
    }

    redo() {
        this.newCoord = this.element.insertCoordinateOnSegment(this.segmentIndex, this.savedAbsX, this.savedAbsY);
        this.coordIndex = this.newCoord.index;
        this.emit(EventTypes.UPDATE_ELEMENT_SHAPE, this.element);
    }
}
